import { Suspense } from "react"

import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

import type { PropsWithClassName } from "~/@types/generics"
import type { TProduct } from "~/components/ui/ProductHeader/_data/types"
import VariantsRow, {
  type VariantsRowProps,
} from "~/components/ui/ProductHeader/components/ProductDetails/components/VariantsRow"
import type { CartLineItemPayload } from "~/components/shared/AnalyticsEvents/types"
import ClientVariantsRowWithVariantSwitch from "~/app/[locale]/products/[slug]/(components)/VariantsRowWithVariantSwitch/index.client"
import type { useVariantSwitch } from "~/app/[locale]/products/[slug]/(hooks)/useVariantSwitch"

export type VariantsRowWithVariantSwitchProps = PropsWithClassName<
  Parameters<typeof useVariantSwitch>[0] &
    Pick<VariantsRowProps, "stockAlertEnabled" | "productType" | "label"> & {
      trackingData: CartLineItemPayload
    } & Pick<TProduct, "collectionsHandles"> & {
      product: UnlikelyProduct
      productId?: TProduct["id"]
      withKleepWidget?: boolean
    }
> & { isInAddToCartPopin?: boolean; withTracking?: boolean }

function VariantsRowWithVariantSwitch({ withTracking = false, ...props }: VariantsRowWithVariantSwitchProps) {
  return (
    <Suspense fallback={<VariantsRow {...props} />}>
      <ClientVariantsRowWithVariantSwitch withTracking={withTracking} {...props} />
    </Suspense>
  )
}

export default VariantsRowWithVariantSwitch
